import { initializePaddle, Paddle } from '@paddle/paddle-js';
import { invokeEvent } from 'shared-base';
import { defaultOptions } from './data.default';
import { setDiscountMapping, setPaddleInstance, setPaddleMapping } from './globals';
import { InitOptions, PaddleMap } from './types';

export let paddleInstance: Paddle;

export const init = (
  token: string,
  paddleMaping: PaddleMap,
  discountMapping: PaddleMap,
  options?: Partial<InitOptions>
) => {
  const mergedOptions = { ...defaultOptions, ...options };
  const { environment, ...rest } = mergedOptions;

  setPaddleMapping(paddleMaping);
  setDiscountMapping(discountMapping);

  initializePaddle({
    environment,
    token,
    checkout: {
      settings: {
        ...rest,
      },
    },
    eventCallback: function (data) {
      invokeEvent('PADDLE', data);
    },
  }).then((paddleInstance: Paddle | undefined) => {
    if (paddleInstance) {
      setPaddleInstance(paddleInstance);
    }
  });
};
